import { css } from "@compiled/react";

import { ExistingUser } from "@/components/signup/site-activation";
import { useSiteActivationContext } from "@/components/signup/site-activation/hooks/site-activation-context";

import {
    FormWithPaymentOverlay,
    PrivacyPolicy,
    WelcomeBackHeading
} from "../../components";

import { PaymentDetailsContent } from "./existing-sites-user-payment";

export const ExistingUserWithPaymentSwitcher = () => {
    const { paymentDetailsView } = useSiteActivationContext();

    return (
        <>
            {paymentDetailsView === "standard" && (
                <h1 css={headerCss}>
                    <WelcomeBackHeading />
                </h1>
            )}
            <FormWithPaymentOverlay
                paymentDetailsPage={
                    paymentDetailsView === "payment" ? (
                        <PaymentDetailsContent />
                    ) : undefined
                }
            >
                <ExistingUser PrivacyPolicy={<PrivacyPolicy />} />
            </FormWithPaymentOverlay>
        </>
    );
};

const headerCss = css({
    margin: 0,
    textAlign: "center"
});
